var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.value
    ? _c(
        "w-modal",
        {
          attrs: { value: _vm.value != null, "escape-close": "" },
          on: {
            input: function ($event) {
              return _vm.onModalInput(false)
            },
          },
        },
        [
          _c(
            "w-card",
            { staticClass: "root" },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.close"),
                          expression: "$ct('common.close')",
                        },
                      ],
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onModalInput(false)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "content" }, [
                _c(
                  "button",
                  {
                    staticClass: "arrow arrow-left",
                    on: {
                      click: function ($event) {
                        return _vm.previous()
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "chevron-left" } })],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "arrow arrow-right",
                    on: {
                      click: function ($event) {
                        return _vm.next()
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "chevron-right" } })],
                  1
                ),
                _c("img", {
                  staticClass: "img",
                  attrs: { src: _vm.url, alt: "Afbeelding" },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }